import React from "react";
import { Header, Image } from "semantic-ui-react";

const AperturarCuentaAhorrosHeader = () => {
  return (
    <>
      <Header as="h1" color="blue">
        <Image src="/assets/icons/ahorro.svg" size="big" /> Apertura tu Cuenta
      </Header>
    </>
  );
};

export default AperturarCuentaAhorrosHeader;
